// @flow
import menuItems from '@lumera_configs/side_menus/buying_guide_menu.json';

import SideMenu from './SideMenu';

const BuyingDiamondsMenu = () => <SideMenu items={menuItems} />;

export default BuyingDiamondsMenu;
